<template>
  <div class="home">
    <img
      class="imhs"
      src="https://xyoss.g.com.cn/xy-production/cms3.0/2023/0512/20230512104428-7457-69822.jpg"
      alt=""
    />
    <div
      class="map-container leaflet-container leaflet-touch-drag leaflet-touch-zoom"
      id="map"
      :class="{ custom: isCustom, 'col-b': map_id == 1 }"
    ></div>
    <div v-if="!isWap" class="menu" :class="[drawer ? 'open' : 'close']">
      <van-popup
        v-model="drawer"
        :overlay="false"
        position="left"
        :style="{ height: '100vh' }"
      >
        <div class="container">
          <div class="header">
            <div class="operation">
              <div class="btn" @click="selectClick">
                <img src="../assets/images/select.png" alt="" />
                <span>{{ markSelectData[isSelectMark] }}</span>
              </div>

              <!--<div class="btn point-btn" @click="creaetCustom">
                <img src="../assets/images/sign.png" alt="">
                <span>{{ isCustom ? '取消自定义' : '自定义点' }}</span>
              </div> -->
            </div>
            <div class="eliminate">
              <p>筛选标记</p>
              <div class="eliminate-btn" @click="clearPorint">清除选择</div>
            </div>
          </div>
          <div class="collapse">
            <van-collapse
              :border="false"
              v-model="activeNames"
              @change="collapseChange"
            >
              <van-collapse-item
                :border="false"
                v-for="(item, index) in dataList1"
                :key="index + 'en'"
                :title="item.name"
                :name="index + 1"
              >
                <div class="select">
                  <div
                    class="items"
                    v-for="item1 in item.resources"
                    :key="item1._id"
                    :class="{ active: item1.is_default }"
                    @click="showSpot(item1)"
                  >
                    <img :src="item1.icon_url" alt="" />
                    <span>{{ item1.name }}</span>
                  </div>
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>
          <div class="footer">
            <div class="saveBtn" @click="saveData">保存</div>
            <p>部分数据来源：www.zeldadungeon.net</p>
          </div>
        </div>
      </van-popup>
      <div class="hrefs">
        <div class="logos">
          <a href="https://map.a9vg.com/zeldakingdom/">
            <img src="../assets/images/logo1.png" alt="" class="logo1" />
          </a>
          <a href="https://www.a9vg.com/" target="_blank">
            <img src="../assets/images/logo2.png" alt="" class="logo2" />
          </a>
        </div>
        <a
          href="https://bbs.a9vg.com/forum-278-1.html"
          target="_blank"
          class="zone"
        ></a>
      </div>
      <div class="wrap">
        <div
          class="area-item"
          v-for="(item, index) in wrapViewList[map_id - 1]"
          :key="index"
          @click="changeMapView(item)"
        >
          <span class="round"></span>
          <div class="icons"></div>
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div class="closeDrawer" @click="drawer = !drawer">
        <img v-if="drawer" src="../assets/images/close-btn.png" alt="" />
        <img v-else src="../assets/images/close-btn1.png" alt="" />
      </div>
      <div class="allPopCon">
        <div class="popupContent" ref="popupContent">
          <div class="map-popup custom-popup">
            <div class="title">编辑自定义标记</div>
            <p>可点击改变点位位置或者拖动点位</p>
            <div class="customList">
              <div
                class="items"
                v-for="(item, index) in customPopupContent"
                :key="index"
                :index="index"
              >
                <img :src="item.icon_url" alt="" />
              </div>
            </div>
            <div class="btns">
              <div class="btn customDelete">删除</div>
              <div class="btn customDetermine">确定</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right-op" v-if="!isWap">
      <div class="btn btn-col" @click="selectMap">
        <img src="../assets/images/layered.png" alt="" />
        <span>地图分层选择</span>
      </div>
      <div class="selectMap" v-if="isSelectMap">
        <div
          class="type"
          v-for="item in mapList"
          :key="item.id"
          :class="{ active: map_id === item.id }"
          @click="changeSelectMap(item.id)"
        >
          {{ item.map_name }}
        </div>
      </div>
      <a
        class="btn"
        href="https://bbs.a9vg.com/thread-8911924-1-1.html"
        target="_blank"
      >
        <img src="../assets/images/recommend.png" alt="" />
        <span>塞尔达攻略合集</span>
      </a>
    </div>
    <div
      :class="{ selectMark: !isWap, selectWapMark: isWap }"
      v-if="isShowSelect"
    >
      <div
        class="type"
        v-for="(item, index) in markSelectData"
        :key="index"
        :class="{ active: isSelectMark === index }"
        @click="changeSelectMark(index)"
      >
        {{ item }}<van-icon name="success" v-if="isSelectMark === index" />
      </div>
    </div>
    <div class="bot-op" v-if="!isWap">
      <!-- <div class="btn-bar">
        <span v-for="(item,index) in ['IOS']" :key="index" :class="{'active':botIos===index}" @click="botIos=index">{{item}}</span>
      </div> -->
      <div class="content">
        <div class="qr">
          <img
            src="https://file1.a9vg.com/source/plugin/myextend/template/image/app/code.jpg"
            alt=""
          />
        </div>
        <div class="text">
          <div class="txt1">扫码下载A9VG APP</div>
          <div class="txt2">看新闻，聊游戏，查攻略，换礼品</div>
        </div>
      </div>
    </div>
    <div class="wap-bot-op" v-if="isWap">
      <!-- <div class="btn custom">
        <img src="" alt="">
      </div> -->
      <div class="btn screen" @click="drawerWap = true">筛选标记</div>
      <div class="btn choice" @click="selectClick">
        <img src="../assets/images/select.png" alt="" />
        <span>{{ markSelectData[isSelectMark] }}</span>
      </div>
      <div class="btn saveWapBtn" @click="saveData">保存</div>
    </div>
    <div class="wapMenu" v-if="isWap">
      <van-popup
        round
        :overlay="false"
        v-model="drawerWap"
        position="bottom"
        :style="{ height: '100%' }"
      >
        <div class="container">
          <div class="eliminate">
            <p>筛选标记</p>
            <div class="eliminate-btn" @click="clearPorint">清除选择</div>
            <div class="closePop" @click="drawerWap = false">
              <van-icon name="arrow-down" />
            </div>
          </div>
          <div class="collapse">
            <van-collapse :border="false" v-model="activeNames">
              <van-collapse-item
                :border="false"
                v-for="(item, index) in dataList1"
                :key="index + 'en'"
                :title="item.name"
                :name="index + 1"
              >
                <div class="select">
                  <div
                    class="items"
                    v-for="item1 in item.resources"
                    :key="item1._id"
                    :class="{ active: item1.is_default }"
                    @click="showSpot(item1)"
                  >
                    <img :src="item1.icon_url" alt="" />
                    <span>{{ item1.name }}</span>
                  </div>
                </div>
              </van-collapse-item>
            </van-collapse>
          </div>
        </div>
      </van-popup>
    </div>
    <div class="wap-top-op" v-if="isWap">
      <a href="/">
        <img src="../assets/images/logo1.png" alt="" class="logo2" />
      </a>
      <a href="https://www.a9vg.com/" target="_blank" rel="noopener noreferrer"
        ><img src="../assets/images/logo2.png" class="logo1" alt="" />
      </a>
      <div class="btn-col" @click="selectMap">
        <img src="../assets/images/layered.png" alt="" />
        <span>地图分层选择</span>
      </div>
      <div class="selectMap" v-if="isSelectMap">
        <div
          class="type"
          v-for="item in mapList"
          :key="item.id"
          :class="{ active: map_id === item.id }"
          @click="changeSelectMap(item.id)"
        >
          {{ item.map_name }}
        </div>
      </div>
    </div>
    <div class="wapPop" v-if="isWapPop">
      <div class="shareBtn" @click="wapShare">分享</div>
      <div class="title">{{ wapPopData.name }}</div>
      <p>{{ wapPopData.desc }}</p>
      <div class="btns" @click="wapMark">
        {{ wapIsMark }}
      </div>
    </div>
    <div :class="{ saveTips: !isWap, saveWapTips: isWap }" v-if="isTips">
      <div class="close" @click="isTips = false">
        <img src="../assets/images/closeBtn.png" alt="" />
      </div>
      <div class="title">提示</div>
      <p>
        已将标记点位存档并生成个人专属链接，访问专属链接后数据将实时保存，有效期180天，还请及时更新存档。
      </p>
      <div class="copyBtn" @click="copyBtnUrl">一键复制</div>
    </div>
    <div :class="{ updateTips: !isWap, updateWapTips: isWap }" v-if="!isUpdate">
      <div class="close" @click="isUpdate = 1">
        <img src="../assets/images/closeBtn.png" alt="" />
      </div>
      <div class="title">版本V0.9:</div>
      <p>·增加点位分享功能</p>
    </div>
  </div>
</template>
<!-- eslint-disable indent -->
<script>
import { mapState, mapMutations } from 'vuex'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import {
  browserRedirect,
  map1Text,
  map2Text,
  map3Text,
  customList,
  customMapUrl,
  wrapViewList,
  getUserId,
  getLatlngPar
} from '../utils/index'
export default {
  name: 'mapView',
  components: {},
  data() {
    return {
      isWap: 0, // 是否是wap
      isSelectMark: 0, // 切换未标记已标记
      isShowSelect: false, // 显示未标记已标记切换弹窗
      activeNames: [], // 折叠面板所有打卡的选项
      drawer: true, // 左侧弹层是否打开
      map: '',
      zoom: 1,
      isCustom: false, // 是否自定义
      layerObj: {}, // 大地图所有的 文字mark
      rootLayerGroup: '', // 大地图根图层
      collapseObj: {}, // 大地图所有的 标点mark
      pointsLayerGroup: '', // 大地图 标点图层
      dataList1: [],
      isSelectMap: false,
      customLayer: '',
      customList: '',
      customPopup: '',
      customCenter: [],
      botIos: 0,
      wholeMap: '',
      partMap: '',
      signPort: [],
      customPopupContent: [],
      map_id: 1,
      drawerWap: false,
      mapCenter: [0, 0],
      mapZoom: 4,
      wrapViewList: [],
      activeZoom: 4,
      wapPopData: {},
      isWapPop: false,
      copyText: '',
      isTips: false,
      markSelectData: ['全部', '未标记', '已标记'],
      wapIsMark: '标记',
      isUpdate: null,
      latlng: [],
      zsLink: '' // 用户专属链接
    }
  },
  created() {
    this.isUpdate = localStorage.getItem('isUpdate1')
    if (!this.isUpdate) {
      localStorage.setItem('isUpdate1', '1')
    }
    this.copyText = getUserId()
    this.latlng = getLatlngPar()
    this.wrapViewList = wrapViewList
    this.customPopupContent = customList
    this.activeZoom = 4
    this.isWap = browserRedirect()
    if (this.isWap) {
      this.mapCenter = this.latlng.length > 0 ? this.latlng : [-40, 50]
      if (this.latlng.length > 0) {
        // location.reload()
        this.mapZoom = 5
        this.activeZoom = 5
      }
      this.mapZoom = 3
    } else {
      this.mapCenter = this.latlng.length > 0 ? this.latlng : [-60, 0]
      if (this.latlng.length > 0) {
        // location.reload()
        this.mapZoom = 5
        this.activeZoom = 5
      }
      console.log(this.mapCenter, 'this.mapCenter')
    }
  },
  computed: {
    ...mapState(['cudtomUserPoint', 'userMakingPoint'])
  },
  async mounted() {
    const uid = getUserId()
    if (uid) {
      const res = await this.$api.getUserMarks(uid)
      if (res.code === 200) {
        this.setUserMakingPoint(res.data)
      }
    }

    this.getMap()
    this.getMapInfo()
  },
  methods: {
    ...mapMutations(['setCudtomUserPoint', 'setUserMakingPoint']),
    async getMapInfo() {
      const res = await this.$api.getMapInfo()
      if (res.data) {
        this.mapList = res.data
        this.initMap()
        this.getMapData()
        this.mapClick()
        this.map_id = res.data[0].id
      }
    },
    wapShare() {
      const _latlng = this.wapPopData.coordinates
      const url = window.location.origin + window.location.pathname + '#/'
      // const url = window.location.href
      const str = 'lat=' + _latlng[0] + '&lng=' + _latlng[1]
      const newUrl = url.includes('?') ? url + str : url + '?' + str
      this.$copyText(newUrl).then(
        (res) => {
          this.$toast('此点位访问地址已复制')
        },
        (err) => {
          this.$toast('复制失败' + err)
        }
      )
    },
    collapseChange(activeNames) {
      activeNames.forEach((item) => {
        this.dataList1[item - 1].is_default = true
      })
    },
    copyBtnUrl() {
      this.$copyText(this.zsLink).then(
        (res) => {
          this.$toast('复制成功')
        },
        (err) => {
          this.$toast('复制失败' + err)
        }
      )
      this.isTips = false
    },
    /** 切换地图 start           */
    selectMap() {
      this.isSelectMap = !this.isSelectMap
    },
    async saveData() {
      // if (getUserId()) {
      //   this.$copyText(window.location.href).then(
      //     res => {
      //       this.$toast('已复制用户连接')
      //     },
      //     err => {
      //       this.$toast('复制失败' + err)
      //     }
      //   )
      //   return
      // }
      const res = await this.$api.getUserId()
      if (res.code === 200) {
        this.copyText = res.data
        var r = window.location.href.split('?')
        this.zsLink = r[0] + '?user=' + res.data
        // window.location.href = r[0] + '?user=' + res.data
        this.setUserMarks()
        // this.setMapData()
        this.isTips = true
      }
    },
    async setUserMarks() {
      const res = await this.$api.setUserMarks({
        uid: this.copyText,
        points: this.userMakingPoint
      })
      console.log('res', res)
    },
    async setMapData() {
      const res = await this.$api.setMapData({
        uid: this.copyText,
        lists: this.dataList1
      })
      console.log('setMapData', res)
    },
    wapMark() {
      const id = this.wapPopData.point_id
      const pointHtl = document.querySelector('.p_' + id)
      const newData = this.userMakingPoint
      if (newData.includes(id)) {
        const index = newData.indexOf(id)
        newData.splice(index, 1)
        pointHtl.classList.remove('active')
      } else {
        newData.push(id)
        pointHtl.classList.add('active')
      }
      this.setUserMakingPoint(newData)
      if (this.copyText && this.copyText !== '') {
        this.setUserMarks()
      }
      this.isWapPop = false
      // this.map.closePopup()
      this.initCollapse()
    },
    initWholeMap() {
      this.pointsLayerGroup.clearLayers()
      this.rootLayerGroup.clearLayers()
      this.wholeMap.remove()
      this.partMap.remove()
      this.part1Map.remove()
      if (this.isWap) {
        this.map.setView([-40, 50], 3)
      } else {
        this.map.setView([-60, 0], 4)
      }
      this.getMapData()
      this.wholeMap.addTo(this.map)
      this.initMarkers(map1Text)
    },
    initPartMap() {
      this.rootLayerGroup.clearLayers()
      this.pointsLayerGroup.clearLayers()
      this.partMap.remove()
      this.wholeMap.remove()
      this.part1Map.remove()
      if (this.isWap) {
        this.map.setView([-40, 50], 3)
      } else {
        this.map.setView([-60, 0], 4)
      }
      this.getMapData()
      this.partMap.addTo(this.map)
      this.initMarkers(map2Text)
    },
    initPart1Map() {
      this.rootLayerGroup.clearLayers()
      this.pointsLayerGroup.clearLayers()
      this.part1Map.remove()
      this.wholeMap.remove()
      this.partMap.remove()
      if (this.isWap) {
        this.map.setView([-40, 50], 3)
      } else {
        this.map.setView([-60, 0], 4)
      }
      this.getMapData()
      this.part1Map.addTo(this.map)
      this.initMarkers(map3Text)
    },
    changeSelectMap(index) {
      this.map_id = index
      this.isSelectMap = false
      if (index === 2) {
        this.initPartMap()
      } else if (index === 3) {
        this.initPart1Map()
      } else {
        this.initWholeMap()
      }
    },
    /** 切换地图 end           */

    // 切换全选或者标记
    changeSelectMark(index) {
      this.isSelectMark = index
      this.isShowSelect = false
      this.pointsLayerGroup.clearLayers()
      this.getIsDefalut().forEach((item) => {
        const signData = this.collapseObj[item][0]
        const noSignData = this.collapseObj[item][1]
        if (index === 2) {
          signData.length > 0 && this.pointsLayerGroup.addLayer(...signData)
        } else if (index === 1) {
          noSignData.length > 0 && this.pointsLayerGroup.addLayer(...noSignData)
        } else {
          signData.length > 0 && this.pointsLayerGroup.addLayer(...signData)
          noSignData.length > 0 && this.pointsLayerGroup.addLayer(...noSignData)
        }
      })
    },
    getIsDefalut() {
      const allPopActive = []
      this.dataList1.forEach((item) => {
        item.resources.forEach((item1) => {
          if (item1.is_default) {
            allPopActive.push(item1.name)
          }
        })
      })
      return allPopActive
    },
    // 添加自定义点
    creaetCustom() {
      if (this.isCustom === true) {
        this.removeFilter(this.customList)
        this.removeFilter(this.customPopup)
      }
      this.isCustom = !this.isCustom
    },
    mapZoomEvent(e) {
      const zoom = e.target.getZoom()
      this.activeZoom = zoom
      this.rootLayerGroup.clearLayers()
      if (this.map_id !== 3) {
        if (zoom >= 6) {
          this.rootLayerGroup.addLayer(this.layerObj.three)
        } else if (zoom >= 5 && zoom < 6) {
          this.rootLayerGroup.addLayer(this.layerObj.two)
        } else if (zoom <= 4) {
          this.rootLayerGroup.addLayer(this.layerObj.one)
        }
      } else {
        if (zoom >= 6) {
          this.rootLayerGroup.addLayer(this.layerObj.two)
        } else {
          this.rootLayerGroup.addLayer(this.layerObj.one)
        }
      }
    },
    removeFilter(t) {
      t && this.map.hasLayer(t) && this.map.removeLayer(t)
    },
    mapClickEvent(e) {
      this.isWapPop = false
      if (this.isCustom) {
        this.removeFilter(this.customList)
        this.removeFilter(this.customPopup)
        this.customCenter = [e.latlng.lat, e.latlng.lng]
        this.customList = L.marker([e.latlng.lat, e.latlng.lng], {
          draggable: true,
          icon: L.divIcon({
            // 自定义标点的图标样式
            className: 'nga-div-icon',
            iconSize: [28, 41],
            iconAnchor: [14, 34],
            popupAnchor: [0, -10],
            html: '<img src="" alt="" />'
          })
        }).addTo(this.map)

        this.customPopup = L.popup({ closeButton: false })
          .setLatLng(e.latlng)
          .setContent(this.$refs.popupContent.innerHTML)
          .openOn(this.map)
        this.customList.on('dragend', (ev1) => {
          const center = [
            ev1.target.getLatLng().lat,
            ev1.target.getLatLng().lng
          ]
          this.customCenter = center
          this.customPopup.setLatLng(center)
        })
      }
    },
    mapPopupEvent(ev) {
      const popupEle = ev.popup.getElement()
      const ss = popupEle.querySelector('.sign')
      const shareHref = popupEle.querySelector('.shareHref')
      const customDelete = popupEle.querySelector('.customDelete')
      if (shareHref) {
        shareHref.addEventListener('click', (e) => {
          const _latlng = ev.popup._latlng
          const url = window.location.origin + window.location.pathname + '#/'
          // const url = window.location.href
          const str = 'lat=' + _latlng.lat + '&lng=' + _latlng.lng
          const newUrl = url.includes('?') ? url + str : url + '?' + str
          this.$copyText(newUrl).then(
            (res) => {
              this.$toast('此点位访问地址已复制')
            },
            (err) => {
              this.$toast('复制失败' + err)
            }
          )
        })
      }
      if (ss) {
        const id = ss.getAttribute('id')
        const newData = this.userMakingPoint
        if (newData.includes(id)) {
          ss.innerHTML = '取消标记'
        } else {
          ss.innerHTML = '标记'
        }
        ss.addEventListener('click', (ev1) => {
          const pointHtl = document.querySelector('.p_' + id)

          if (newData.includes(id)) {
            const index = newData.indexOf(id)
            newData.splice(index, 1)
            pointHtl.classList.remove('active')
          } else {
            newData.push(id)
            pointHtl.classList.add('active')
          }
          this.setUserMakingPoint(newData)
          if (this.copyText && this.copyText !== '') {
            this.setUserMarks()
          }
          this.map.closePopup()
          this.initCollapse()
          // ev.popup.setContent(mapPop)
        })
      }
      if (customDelete) {
        customDelete.addEventListener('click', (ev) => {
          this.removeFilter(this.customList)
          this.removeFilter(this.customPopup)
          this.isCustom = false
        })
      }
    },
    mapClick() {
      const that = this
      this.map.on('zoomend', (e) => {
        that.mapZoomEvent(e)
      })
      this.map.on('click', (e) => {
        that.mapClickEvent(e)
      })
      this.map.on('popupopen', (ev) => {
        that.mapPopupEvent(ev)
      })
    },
    handleClose() {},

    selectClick() {
      this.isShowSelect = !this.isShowSelect
      // this.rootLayerGroup.clearLayers()
      // this.rootLayerGroup.addLayer(this.layerObj.one)
    },
    // 初始化map地图
    initMap() {
      L.TileLayer.Whole = L.TileLayer.extend({
        getTileUrl: ({ x, y, z }) => {
          return customMapUrl(x, y, z, this.mapList[0].background)
        }
      })
      L.tileLayer.whole = () => {
        return new L.TileLayer.Whole()
      }
      this.wholeMap = L.tileLayer.whole()

      L.TileLayer.Part = L.TileLayer.extend({
        getTileUrl: ({ x, y, z }) => {
          return customMapUrl(x, y, z, this.mapList[1].background)
        }
      })
      L.tileLayer.part = () => {
        return new L.TileLayer.Part()
      }
      this.partMap = L.tileLayer.part()

      L.TileLayer.Part1 = L.TileLayer.extend({
        getTileUrl: ({ x, y, z }) => {
          return customMapUrl(x, y, z, this.mapList[2].background)
        }
      })
      L.tileLayer.part1 = () => {
        return new L.TileLayer.Part1()
      }
      this.part1Map = L.tileLayer.part1()

      this.wholeMap.addTo(this.map)
      this.rootLayerGroup = L.featureGroup().addTo(this.map) // 添加根图层（方便管理其他图层）
      this.pointsLayerGroup = L.featureGroup().addTo(this.map)

      this.initMarkers(map1Text)
    },
    getMapData() {
      this.activeNames = []
      this.getCollapseList().then((res) => {
        if (res.code == 200) {
          res.data.forEach((item, index) => {
            if (this.latlng.length > 0) {
              item.is_default = 0
              item.resources.forEach((item1) => {
                item1.is_default = 0
                item1.points.forEach((item2) => {
                  if (item2.coordinates[0] == this.latlng[0]) {
                    item1.is_default = 1
                    item.is_default = 1
                  }
                })
              })
            }
            if (item.is_default === 1) {
              this.activeNames.push(index + 1)
            }
          })
          this.dataList1 = res.data
          this.initCollapse(true)
        }
      })
    },
    // L.map(this.map)初始化
    getMap() {
      // 配置地图边界等信息
      // 左上 右下
      // const maxBounds = new L.LatLngBounds([2, -140.45], [-100, 164]) // 前边是[纬度(y),经度(x)西经为负数][纬度,东经] 通过定义矩形西南角点和东北角点来创建经纬度的矩形框
      const maxBounds = this.isWap
        ? new L.LatLngBounds([-100, -140.45], [0, 164])
        : new L.LatLngBounds([37, -240.45], [-100, 164])
      const options = {
        // zoomDelta: 0.5,
        // zoomSnap: 0.5,
        maxZoom: 7,
        minZoom: 3,
        maxBounds: maxBounds, // 地图边界 拖动超过边界会自动回弹
        attributionControl: !1, // 是否显示右下角 跳转链接 标志 可更改
        zoomControl: !1
        // layers: [osm, cities]
      }
      this.map = L.map('map', options).setView(this.mapCenter, this.mapZoom) // 居中展示，初始倍数为1倍图
    },
    // 请求全局数据
    getCollapseList() {
      return this.$api.getCollapseList({ map_id: this.map_id })
    },
    // 初始化地图上的点的group
    async initCollapse(isInit) {
      this.dataList1.forEach((item, index) => {
        item.resources.forEach((item1, index1) => {
          this.collapseObj[item1.name] = [[], []]
          const myLayerGroup = new L.LayerGroup()
          const myLayerGroupSign = new L.LayerGroup()
          item1.points.forEach((item2) => {
            const is_sign = this.userMakingPoint.includes(item2.point_id)
            const marker = this.initBindPopup(item2, item1, index, index1)
            marker.openPopup()
            if (is_sign) {
              myLayerGroupSign.addLayer(marker)
              this.collapseObj[item1.name][0].push(myLayerGroupSign)
            } else {
              myLayerGroup.addLayer(marker)
              this.collapseObj[item1.name][1].push(myLayerGroup)
            }
          })
          if (item1.is_default && isInit) {
            this.pointsLayerGroup.addLayer(myLayerGroup)
            this.pointsLayerGroup.addLayer(myLayerGroupSign)
            // this.map.openPopup({ lat: this.latlng[0], lng: this.latlng[1] })
          }

          // myLayerGroup.on('click', this.openMobilePopup)
        })
      })
    },
    // 地图上点的popup 的html
    initBindPopup(item2, item1, index, index1) {
      const is_sign = this.userMakingPoint.includes(item2.point_id)
      const marker = L.marker(item2.coordinates, {
        icon: L.divIcon({
          // 自定义标点的图标样式
          className: this.isWap
            ? is_sign
              ? 'porintWapMap active p_' + item2.point_id
              : 'porintWapMap p_' + item2.point_id
            : is_sign
            ? `porintMap active p_${item2.point_id}`
            : 'porintMap p_' + item2.point_id,
          // iconSize: [50, 28],
          iconAnchor: [14, 40],
          popupAnchor: [0, -35],
          html: `<div class="markPoints"><img src="${item1.icon_url} " alt="${index},${index1},${item2.point_id}"/></div>`
        })
        // markerId: item1.index
      })
      let htmlStrImg = ''
      if (item2.images && item2.images.length > 0) {
        item2.images.forEach((item) => {
          htmlStrImg += '<img src="' + item + '" alt=""/>'
        })
      }
      const htmlHref = item2.href
        ? `<a class="btn" href="${item2.href}" target="_blank">详细攻略</a>`
        : ''
      this.isWap
        ? marker.on('click', this.openMobilePopup)
        : marker
            .bindPopup(
              `<div class="map-popup p_${item2.point_id}">
                <div class="title">${item2.name}</div>
                  <p>${item2.desc}</p>
                  ${htmlStrImg}
                  <div class="btns">
                    ${htmlHref}
                    <div class="btn sign" id="${item2.point_id}">${
                is_sign ? '取消标记' : '标记'
              }</div>
                </div>
                <div class="shareHref">分享</div>
              </div>`,
              {
                closeButton: false
              }
            )
            .on('click', this.openPcPopup)

      return marker
    },
    openPcPopup(ev) {},
    openMobilePopup(t) {
      if (this.isWap) {
        const popEme = t.target.getElement()
        const imgHtl = popEme.querySelector('.markPoints img')
        const con = imgHtl.getAttribute('alt').split(',')
        const index = con[0]
        const index1 = con[1]
        const items = this.dataList1[index].resources[index1].points.filter(
          (item) => item.point_id == con[2]
        )
        const is_sign = this.userMakingPoint.includes(items[0].point_id)
        this.wapIsMark = is_sign ? '取消标记' : '标记'
        this.isWapPop = true
        this.wapPopData = items[0]
      }
    },
    // 初始化地图上区域文字标记
    initMarkers(data) {
      this.layerObj = {}
      data.forEach((item) => {
        const myLayerGroup = new L.LayerGroup()
        item.children.forEach((item1) => {
          const marker = L.marker(item1.latlng, {
            icon: L.divIcon({
              // 自定义标点的图标样式
              iconSize: [100, 20],
              className: this.isWap ? 'iconWapMap' : 'iconMap',
              html: item1.name
            }),
            markerId: item1.index
          })
          myLayerGroup.addLayer(marker)
        })
        this.layerObj[item.name] = myLayerGroup
      })
      console.log(this.activeZoom, 'this.activeZoom ')
      if (this.map_id !== 3) {
        if (this.activeZoom >= 6) {
          this.rootLayerGroup.addLayer(this.layerObj.three)
        } else if (this.activeZoom >= 5 && this.activeZoom < 6) {
          this.rootLayerGroup.addLayer(this.layerObj.two)
        } else if (this.activeZoom <= 4) {
          this.rootLayerGroup.addLayer(this.layerObj.one)
        }
      } else {
        if (this.activeZoom >= 6) {
          this.rootLayerGroup.addLayer(this.layerObj.two)
        } else {
          this.rootLayerGroup.addLayer(this.layerObj.one)
        }
      }
    },
    // 显示地图上这个类目的点
    showSpot(item) {
      if (item.points.length != 0) {
        const a = this.collapseObj[item.name][1]
        const b = this.collapseObj[item.name][0]
        if (item.is_default) {
          a.length > 0 && this.pointsLayerGroup.removeLayer(...a)
          b.length > 0 && this.pointsLayerGroup.removeLayer(...b)
        } else {
          a.length > 0 && this.pointsLayerGroup.addLayer(...a)
          b.length > 0 && this.pointsLayerGroup.addLayer(...b)
        }
      }
      item.is_default = !item.is_default
      this.customItem = item
    },
    // 地图展示指定区域
    changeMapView(item) {
      this.map.flyTo(item.view, item.zoom)
    },
    // 清除地图上所有点的展示
    clearPorint() {
      this.dataList1.forEach((item) => {
        item.resources.forEach((item1) => {
          item1.is_default = false
        })
      })
      this.pointsLayerGroup.clearLayers()
    }
  }
}
</script>
<style lang="scss">
#map {
  width: 100vw;
  height: 100vh;
}
/* prettier-ignore */
.home {
  // height: auto;
  position: relative;
  color: #fefbdd;
  font-size: 12PX;
  .imhs {
    left: -999999999PX;
    top:-999999PX;
    position: absolute;
  }
  .popupContent {
    width: 0;
    height: 0;
    overflow: hidden;
  }
  .allPopCon {
    // display: none;
  }
  .van-popup {
    position: relative;
    z-index: 99999!important;
    background: #0f0204;
  }
  .van-cell {
    color: #fefbdd;
    height: 46PX;
    text-align: left;
    background: rgba($color: #000000, $alpha: 0);
    font-size: 16PX;
    line-height: 16PX;
    padding: 15PX;
    .van-cell__right-icon {
      line-height: 16PX;
      font-size: 16PX;
    }
  }
  .van-cell--clickable:active {
    background: none !important;
  }
  .van-collapse-item__content {
    padding: 15PX;
    background: none;
    // border-top: 1PX solid #1c140f;
    // border-bottom: 1PX solid #1c140f;
  }
  .menu {
    z-index: 9999;
    position: fixed;
    top: 0;
    left: 0;
    width: 280PX;
    height: 100vh;
    .van-cell {
      color: #fefbdd;
      height: 46PX;
      text-align: left;
      background: rgba($color: #000000, $alpha: 0);
      font-size: 16PX;
      line-height: 16PX;
      padding: 15PX;
      .van-cell__right-icon {
        line-height: 16PX;
        font-size: 16PX;
      }
    }
    &.close {
      width: 44PX;
      animation: drawClose 0.09s ease-in 0s 1;
      .wrap {
        right: 0!important;
      }
      .closeDrawer {
        right: 0!important;
      }
    }
    &.open {
      width: 280PX;
      animation: drawOpen 0.15s ease-in 0s 1;
    }
    .container {
      height: 100vh;
      overflow-y: auto;
      box-sizing: border-box;
      padding-top: 232PX;
      //  padding-top: 180PX;
      padding-bottom: 58PX;
      .header {
        z-index: 99999;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: auto;
        padding: 0 15PX;
        background: url('../assets/images/header-title.png') center no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;

        .operation {
          position: relative;
          padding-top: 145PX;
          // padding-top: 125PX;
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 18PX;
          .btn {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 118PX;
            height: 28PX;
            background: #362c2a;
            border-radius: 2PX;
            line-height: 28PX;
            box-sizing: border-box;
            text-align: center;
            cursor: pointer;
            img{
              height: 16PX;
              margin-right: 6PX;
            }
          }
          .point-btn {
          }

        }
        .eliminate {
          display: flex;
          justify-content: space-between;
          p {
            font-size: 16PX;
            font-weight: bold;

            line-height: 24PX;
          }
          .eliminate-btn {
            width: 64PX;
            height: 24PX;
            background: rgba(15, 2, 4, 0.8);
            border-radius: 14PX;
            border: 1PX solid #453226;

            line-height: 24PX;
            cursor: pointer;
          }
        }
      }
      .collapse {
        .select {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        }
        .items {
          position: relative;
          display: flex;
          align-items: center;
          width: 122PX;
          height: 40PX;
          background: rgba(255, 255, 255, 0.05);
            border: 0.01rem solid rgba(0, 0, 0, 0.1);
          font-size: 14PX;
          line-height: 40PX;
          margin-bottom: 8PX;
          box-sizing: border-box;
          padding: 8PX;
          cursor: pointer;
          span {
            display: block;
            width: 100PX;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &.active {
            background: #000000;
          border-radius: 2PX;
          border: 1PX solid #453226;

          }
          img {
            width: 24PX;
            margin-right: 8PX;
          }
          .set {
            z-index: 99999;
            position: absolute;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 14PX;
            height: 14PX;
            margin-right: 4PX;
          }
          &:hover {
            background: #000000;
          border-radius: 2PX;
          border: 1PX solid #453226;
          }
        }
      }
      .footer {
        width: 100%;
        z-index: 99999;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 78PX;
        background: #0f0204;
        padding-top: 15PX;
        .saveBtn {
          width: 118PX;
          height: 28PX;
          margin: 0 auto;
          line-height: 28PX;
          background: #362c2a;
          border-radius: 2PX;
          cursor: pointer;
        }
        p{
          padding: 5PX 0;
        }
      }
    }
    .hrefs {
      z-index: 99999;
      position: absolute;
      top: 20PX;
      left: 15PX;
      .logos {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 20PX;
        // padding: 0 15PX;
        .logo1 {
          width: 104PX;
          margin-right: 24PX;
        }
        .logo2 {
          width: 116PX;
        }
      }
      .zone {
        display: block;
        width: 250PX;
        height: 44PX;
        background: url('../assets/images/herf.png') center no-repeat;
        background-size: 100% 100%;
        margin-bottom: 15PX;
      }
    }
    .closeDrawer {
      position: absolute;
      bottom: 10PX;
      right: -44PX;
      width: 44PX;
      height: 56PX;
      background: rgba(28, 20, 15, 0.95);
      border-radius: 0px 4px 4px 0px;
      // border: 1px solid #453226;
      cursor: pointer;
      box-sizing: border-box;
      z-index: 2000;
      img {
        display: block;
        margin: 20PX auto 0;
        width: 8PX;
        height: 12PX;
      }
    }
    .wrap {
      position: absolute;
      top: 50%;
      right: -44PX;
      transform: translateY(-50%);
      z-index: 2000;
      // display: flex;
      // flex-direction: column;
      width: 44PX;
      .area-item {
        position: relative;
        width: 100%;
        height: 64PX;
        background-color: #3d2b21;
        background-size: 100% 100%;
        overflow: hidden;
        img,
        span {
          top: 50%;
          transform: translateY(-50%);
        }
        .round {
          width: 32PX;
          height: 32PX;
          left: 6PX;
          background: #0e0103;
          border-radius: 50%;
          opacity: 0;
        }
        .icons {
          position: absolute;
          width: 20PX;
          height: 20PX;
          left: 13PX;
          top: 21PX;
          background: url('../assets/images/herf-icon.png') center no-repeat;
          background-size: 100% 100%;
          &.active{
            background: url('../assets/images/herf-icon_active.png') center no-repeat;
            background-size: 100% 100%;
          }
          &:hover {
            background: url('../assets/images/herf-icon_active.png') center no-repeat;
            background-size: 100% 100%;
          }
        }
        span {
          position: absolute;
          width: 80PX;
          left: 44PX;
          font-weight: bold;
          color: rgba(255, 255, 255, 0.9);
        }
        &:hover {
          width: 128PX;
          background-image: url('../assets/images/area-item_active.png');
          animation: active-area-frames 0.1s linear forwards;
          background-color: rgba(0, 0, 0, 0);
          .round {
            opacity: 1;
          }
        }
      }
    }
  }
  .map-container {
    position: relative;
    background: #141d2b;
    overflow: hidden;
    touch-action: none;
    img {
      height: auto!important;
    }
    &.custom {
      cursor: url('https://static-web.ghzs.com/tool/ysmap/custom/point_mouse.png')
          20 40,
        grab;
    }
    &.col-b{
      background: #000000;
    }
    .leaflet-popup {
      // left: -145PX!important;
      bottom: 28PX!important;
      margin-bottom: 0;
      .leaflet-popup-content-wrapper {
        background: rgba(28, 20, 15, 0.95);
        min-width: 214PX !important;
        border-radius: 10PX;
      }
      .leaflet-popup-content {
        // width: 270PX;
        margin: 15PX
      }
      .leaflet-popup-tip {
        background: rgba(28, 20, 15, 0.95);
        width: 25PX!important;
        height: 25PX!important;
        margin-top: -10PX;
      }
    }
    .porintWapMap {
      // width: 32px!important;
      // height: 42px!important;
      &.active {
        opacity: 0.4;
      }
      .markPoints {
        width: 32px;
        height: 42px;
        background: url('../assets/images/points-bg.png') center no-repeat;
        background-size: 100% 100%;
        box-sizing: border-box;
        padding:5px;
        // margin-left: -10px !important;
        // margin-top: -20px !important;
        img {
          display: block;
          width: 23px;
          height: 23px;
          border-radius: 50%;
        }
      }
    }
    .porintMap {
      &.active{
        opacity: 0.4;
      }
      .markPoints {
        width: 32PX;
        height: 41PX;
        background: url('../assets/images/points-bg.png') center no-repeat;
        background-size: 100% 100%;
        padding: 6PX;
        // margin-left: -10PX !important;
        // margin-top: -20PX !important;
        img {
          display: block;
          width: 20PX;
          height: 20PX;
          border-radius: 50%;
        }
      }
    }

    .nga-div-icon{
      padding: 4PX;
      width: 40PX!important;
      height: 40PX!important;
      margin-left: -20PX !important;
      margin-top: -40PX !important;
      background-image: url('../assets/images/pointsCustom-bg.png');
      background-size: 100%;
      visibility: visible;
      img {
        display: block;
        width: 24PX!important;
        border-radius: 50%;
        // margin-left: 4PX;
        // margin-top: 3PX;
      }
    }
    .hero-map-gis-cover {
      min-width: 108PX;
      width: auto;
      font-size: 16PX;
      color: #fff;
      text-align: left;
    }
    .iconMap {
      text-align: center;
      background: rgba($color: #000000, $alpha: 0);
      font-size: 20PX;
      color: #fff;
    }
    .iconWapMap {
      text-align: center;
      background: rgba($color: #000000, $alpha: 0);
      font-size: 20px;
      color: #fff;
    }
    .map-popup {
      width: 240PX;
      position: relative;
      font-size: 12PX;
      color: #85786d;
      line-height: 18PX;
      padding-bottom: 39PX;
      img{
        display: block;
        height: 135PX!important;
        width: 100%;
        margin-bottom: 10PX;
        object-fit: cover;
      }
      .btns {
        width: 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        p{
          margin-bottom: 0;
        }
      }
      &.custom-popup {
        width: 184PX;
        padding-bottom: 5PX;
        .btns {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .btn{
            text-align: center;
            width: 88PX;
            height: 24PX;
            line-height: 24PX;
            background: #43312C;
            border-radius: 2PX;
            cursor: pointer;
          }
        }
      }
      .title {
        font-size: 16PX;
        line-height: 24PX;
        font-weight: bold;
      }
      p {
        margin: 0 0 10PX;
      }
      .btn {
        color: #85786d;
        display: flex;
        justify-content: center;
        align-items: center;

        width: 115PX;
        height: 24PX;
        background: #43312c;
        border-radius: 2PX;
        cursor: pointer;
      }
      .sign {
        margin-left: 10PX;
        img {
          width: 14PX;
          margin-right: 6px;
        }
      }
      .shareHref {
        cursor: pointer;
        position: absolute;
        top: -65PX;
        right: -20PX;
        text-align: center;
        width: 72PX;
        height: 40PX;
        background: linear-gradient(90deg, #BE9E5B 0%, #B38539 100%);
        border-radius: 10PX;
        border: 1PX solid #8C6734;
        font-size: 14PX;
        color: #FEFBDD;
        line-height: 38PX;
      }
      .content {
        display: flex;
      }
    }
  }
  .customList {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12PX;
    img {
      width: 24PX;
    }
  }
  .selectMark {
    z-index: 99999;
    position: absolute;
    left: 15PX;
    top: 180PX;
    width: 118PX;
    // height: 133PX;
    background: #261718;
    border-radius: 2PX;
    line-height: 28PX;

    cursor: pointer;
    box-sizing: border-box;
    padding: 0 15PX;
    .title {
      width: 100%;
      background: none;

      color: #85786d;
      text-align: left;
    }
    .type {
      position: relative;
      background: none;
      text-align: left;
      &.active {
        color: #ffbf76;
      }
    }
    .van-icon-success {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .selectWapMark {
    z-index: 99999;
    position: absolute;
    right: 80px;
    bottom: 80px;
    width: 118px;
    // height: 133px;
    background: #261718;
    border-radius: 2px;
    line-height: 28px;

    cursor: pointer;
    box-sizing: border-box;
    padding: 0 15px;
    .title {
      width: 100%;
      background: none;

      color: #85786d;
      text-align: left;
    }
    .type {
      position: relative;
      background: none;
      text-align: left;
      &.active {
        color: #ffbf76;
      }
    }
    .van-icon-success {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .right-op {
    z-index: 9999;
    position: absolute;
    top: 20PX;
    right: 20PX;
    display: flex;
    align-items: center;

    .btn {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FEFBDD;
      height: 40PX;
      cursor: pointer;
      img{
        margin-right: 6PX;
      }
    }
    .btn-col {
      width: 152PX;
      background: linear-gradient(90deg, #BE9E5B 0%, #B38539 100%);
      border-radius: 4PX;
      border: 1PX solid #8C6734;
    }
    a{
      width: 176PX;
      background: rgba(15,2,4,0.7);
      border-radius: 4PX;
      margin-left: 20PX;
    }
    .selectMap {
      position: absolute;
      bottom: -110PX;
      left: 0;
      width: 176PX;
      background: #261718;
      border-radius: 4PX;
      div {
        height: 32PX;
        line-height: 32PX;
      }
      .title {
        color: #85786D;
      }
      .type{
        font-size: 14PX;
        cursor: pointer;
        &.active {
          color: #FFBF76;
        }
      }
    }
  }
  .bot-op {
    z-index: 9999;
    position: fixed;
    bottom: 27PX;
    right: 20PX;
    width: 280PX;
    // height: 114PX;
    background: rgba(28,20,15,0.95);
    border-radius: 10PX;
    box-sizing: border-box;
    padding: 15PX;
    .btn-bar {
      display: flex;
      align-items: center;
      width: 100%;
      height: 24PX;
      line-height: 24PX;
      background: #0F0204;
      border-radius: 2PX;
      cursor: pointer;
      span{
        display: block;
        width: 100%;
        height: 24PX;
        &.active {
          background: #43312C;
          border-radius: 2PX;
        }
      }
    }
    .content {
      display: flex;
      align-items: center;
      // margin-top: 16PX;
      .qr{
        width: 64PX;
        height: 64PX;
        margin-right: 12PX;
        // background: #fff;
        img {
          width: 100%;
        }
      }
      .text{
        text-align: left;
        .text1 {
          font-size: 16PX;
          font-weight: bold;
          color: #FEFBDD;
          line-height: 24PX;
        }
        .text2 {
          font-size: 14PX;
          color: #85786D;
          line-height: 18PX;
        }
      }
    }
  }
  .wapMenu{
    z-index: 999;
    position: fixed;
    bottom: 0;
    left: 0;
    .van-cell {
      color: #fefbdd;
      height: 46px;
      text-align: left;
      background: rgba($color: #000000, $alpha: 0);
      font-size: 16px;
      line-height: 16px;
      padding: 15px;
      .van-cell__right-icon {
        line-height: 16px;
        font-size: 16px;
      }
    }
    .container {
      width: 100vw;
      box-sizing: border-box;
      padding-top: 72px;
      height: 457px;
      overflow-y: auto;
    }
    .eliminate {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 99999;
      width: 100%;
      background: #1C1112;
      display: flex;
      align-items: center;
      padding:  16px 15px;;
      p {
        font-size: 16px;
        font-weight: bold;
        line-height: 24px;
        margin-right: 20px;
      }
      .eliminate-btn {
        width: 88px;
        height: 40px;
        background: rgba(15,2,4,0.8);
        border-radius: 10px;
        border: 1px solid #453226;
        font-size: 14px;
        line-height: 40px;
        cursor: pointer;
      }
      .closePop {
        position: absolute;
        top: 16px;
        right: 15px;
        width: 40px;
        height: 40px;
        background: rgba(15,2,4,0.8);
        border-radius: 10px;
        border: 1px solid #453226;
        line-height: 40px;
        // color: #000;
      }
    }
    .select {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      .items {
        display: flex;
        align-items: center;
        width: 118px;
        height: 40px;

          background: rgba(255, 255, 255, 0.05);
          border: 1px solid rgba(0, 0, 0, 0.1);
        font-size: 14px;
        line-height: 40px;
        margin-bottom: 8px;
        box-sizing: border-box;
        padding: 8px;
        cursor: pointer;
        span {
          display: block;
          width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        &.active {
          background: #000000;
        border-radius: 2px;
        border: 1px solid #453226;
        }
        img {
          width: 24px;
          margin-right: 8px;
        }
      }
    }
  }
  .wapPop {
    position: fixed;
    z-index: 990;
    left: 50%;
    transform: translate(-50%);
    bottom: 90px;
    width: 94%;
    font-size: 12px;
    color: #85786d;
    background: #0f0204;
    line-height: 18px;
    padding: 20px 20px 55px;
    border-radius: 10px;
    text-align: left;
      .shareBtn {
        cursor: pointer;
        position: absolute;
        top: -45px;
        right: 0px;
        text-align: center;
        width: 72px;
        height: 40px;
        background: linear-gradient(90deg, #BE9E5B 0%, #B38539 100%);
        border-radius: 10px;
        border: 1px solid #8C6734;
        font-size: 14px;
        color: #FEFBDD;
        line-height: 38px;
      }
      .btns {
        width: 160px;
        height: 35px;
        background: #1C1112;
        // text-align: center;
        position: absolute;
        right: 20px;
        bottom: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        p{
          margin-bottom: 0;
        }
      }
      &.custom-popup {
        width: 184px;
        padding-bottom: 5px;
        .btns {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .btn{
            text-align: center;
            width: 88px;
            height: 24px;
            line-height: 24px;
            background: #43312C;
            border-radius: 2px;
            cursor: pointer;
          }
        }
      }
      .title {
        font-size: 16PX;
        line-height: 24PX;
        font-weight: bold;
      }
      p {
        margin: 0 0 10PX;
      }
      img {
        max-height: 135PX;
      }
      .sign {
        display: flex;
        justify-content: center;
        align-items: center;

        width: 88PX;
        height: 24PX;
        background: #43312c;
        border-radius: 2PX;
        cursor: pointer;
        img {
          width: 14PX;
          margin-right: 6px;
        }
      }
      .content {
        display: flex;
      }
    }
  .wap-bot-op {
    position: fixed;
    z-index: 990;
    left: 0;
    bottom: 30px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      line-height: 40px;
      height: 40px;
      background: rgba(38,23,24,0.9);
      border-radius: 10px;
      border: 1px solid #43312C;
      font-size: 14px;
      &.custom{
        width: 40px;
        margin-left: 12px;
      }
      &.screen{
        width: 120px;
        // margin-left: 48px;
      }
      &.choice{
        display: flex;
        align-items: center;
        justify-content: center;
        width: 84px;
        margin-left: 10px;
        img {
          width: 16px;
          margin-right: 6px;
        }
      }
      &.saveWapBtn {
        width: 60px;
        margin-left: 24px;
      }
    }

  }
  .wap-top-op{
    position: fixed;
    z-index: 9999;
    top: 24px;
    left: 13px;
    display: flex;
    align-items: center;
    img{
      display: block;
    }
    .logo2{
      height: 35px;
      margin-right: 11px;
    }
    .logo1{
      height: 26px;
      margin-right: 14px;
    }
    .btn-col{
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FEFBDD;
      height: 40PX;
      cursor: pointer;
      width: 152px;
      background: linear-gradient(90deg, #BE9E5B 0%, #B38539 100%);
      border-radius: 4px;
      border: 1px solid #8C6734;

      img{
        margin-right: 6PX;
      }
    }
    .selectMap {
      position: absolute;
      bottom: -110px;
      right: 0;
      width: 176px;
      background: #261718;
      border-radius: 4px;
      div {
        height: 32px;
        line-height: 32px;
      }
      .title {
        color: #85786D;
      }
      .type{
        font-size: 14px;
        cursor: pointer;
        &.active {
          color: #FFBF76;
        }
      }
    }
  }
  .saveTips {
    position: fixed;
    z-index: 999999;
    left: 50%;
    top: 50%;
    transform: translate(-30%,-50%);
    width: 280PX;
    height: 166PX;
    background: rgba(28,20,15,0.95);
    border-radius: 10PX;
    .title{
      text-align: center;
      height: 56PX;
      font-size: 16PX;
      font-weight: bold;
      color: #FEFBDD;
      line-height: 56PX;
    }
    .close {
      position: absolute;
      top: 20PX;
      right: 20PX;
      cursor: pointer;
      img {
        width: 14PX;
      }
    }
    p{
      margin: 0 auto;
      width: 240PX;
      font-size: 12PX;
      font-weight: 400;
      color: #85786D;
      line-height: 18PX;
    }
    .copyBtn {
      margin: 20PX auto 0;
      width: 104PX;
      line-height: 24PX;
      background: #43312C;
      border-radius: 2PX;
      color: #FEFBDD;
      font-size: 12PX;
      cursor: pointer;
    }
  }
  .saveWapTips {
    position: fixed;
    z-index: 999999;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 280px;
    height: 166px;
    background: rgba(28,20,15,0.95);
    border-radius: 10px;
    .title{
      text-align: center;
      height: 56px;
      font-size: 16px;
      font-weight: bold;
      color: #FEFBDD;
      line-height: 56px;
    }
    .close {
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
      img {
        width: 14px;
      }
    }
    p{
      margin: 0 auto;
      width: 240px;
      font-size: 12px;
      font-weight: 400;
      color: #85786D;
      line-height: 18px;
    }
    .copyBtn {
      margin: 20px auto 0;
      width: 104px;
      line-height: 24px;
      background: #43312C;
      border-radius: 2px;
      color: #FEFBDD;
      font-size: 12px;
      cursor: pointer;
    }
  }
  .updateTips {
    position: fixed;
    z-index: 999999;
    left: 50%;
    top: 50%;
    transform: translate(-30%,-50%);
    width: 280PX;
    height: 166PX;
    background: rgba(28,20,15,0.95);
    border-radius: 10PX;
    .title{
      text-align: center;
      height: 56PX;
      font-size: 16PX;
      font-weight: bold;
      color: #FEFBDD;
      line-height: 56PX;
      margin-bottom: 20PX;
    }
    .close {
      position: absolute;
      top: 20PX;
      right: 20PX;
      cursor: pointer;
      img {
        width: 14PX;
      }
    }
    p{
      margin: 0 auto;
      width: 240PX;
      font-size: 16PX;
      font-weight: 400;
      color: #85786D;
      line-height: 18PX;
    }
  }
  .updateWapTips {
    position: fixed;
    z-index: 999999;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 280px;
    height: 166px;
    background: rgba(28,20,15,0.95);
    border-radius: 10px;
    .title{
      text-align: center;
      height: 56px;
      font-size: 16px;
      font-weight: bold;
      color: #FEFBDD;
      line-height: 56px;
      margin-bottom: 20px;
    }
    .close {
      position: absolute;
      top: 20px;
      right: 20px;
      cursor: pointer;
      img {
        width: 14px;
      }
    }
    p{
      margin: 0 auto;
      width: 240px;
      font-size: 12px;
      font-weight: 400;
      color: #85786D;
      line-height: 18px;
    }
  }

}
@keyframes drawOpen {
  0% {
    width: 44px;
  }
  100% {
    width: 280px;
  }
}
@keyframes drawClose {
  0% {
    width: 280px;
  }
  100% {
    width: 44px;
  }
}
@keyframes active-area-frames {
  0% {
    width: 44px;
  }
  100% {
    width: 128px;
  }
}
</style>
